import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export interface HygieneCleaningImageDialogData {
  picture: any;
}

@Component({
  selector: 'app-hygine-cleaning-dialog',
  templateUrl: './hygine-cleaning-dialog.component.html',
  styleUrls: ['./hygine-cleaning-dialog.component.scss']
})
export class HygineCleaningDialogComponent {
 picture: any;
  staffList: any[] = [];
  campusName = '';
  buildingName = '';
  /** Activity report: imageUrl, activityName, floorName, roomDisplayName */
  isActivityItem = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dialogRef: MatDialogRef<HygineCleaningDialogComponent>
  ) {
    this.picture = data.picture;
    const p = data.picture as any;
    this.isActivityItem = p && ('activityName' in p && 'imageUrl' in p);
    this.staffList = Array.isArray(p?.staffDetails) ? p.staffDetails : [];
    this.campusName = p?.campusName ?? '';
    this.buildingName = p?.buildingName ?? '';
  }

  get imageSrc(): string {
    const p = this.picture;
    return p?.imageUrl ?? p?.fileName ?? '';
  }

  get displayLabel(): string {
    const p = this.picture;
    return p?.activityName ?? p?.departmentName ?? '';
  }

  close(): void {
    this.dialogRef.close();
  }

  formatHygieneTime(dateStr: string): string {
    if (!dateStr) return '';
    let timePart = '';
    if (typeof dateStr === 'string' && dateStr.includes('T')) {
      const afterT = dateStr.split('T')[1] || '';
      timePart = afterT.split('.')[0].split('+')[0].split('-')[0].trim();
    } else {
      const parts = dateStr.split(' ');
      if (parts.length >= 2) timePart = parts[1];
    }
    if (timePart && timePart !== '00:00:00') {
      const [h, m, s] = timePart.split(':');
      const hh = parseInt(h || '0', 10);
      const ampm = hh >= 12 ? 'PM' : 'AM';
      const h12 = hh % 12 || 12;
      return `${String(h12).padStart(2, '0')}:${m || '00'}:${s || '00'} ${ampm}`;
    }
    return (dateStr.split && dateStr.split('T')[0]) || (dateStr.split && dateStr.split(' ')[0]) || String(dateStr);
  }

  get displayTime(): string {
    const s = this.picture?.capturedTime ?? this.picture?.hygieneDate;
    return s ? this.formatHygieneTime(s) : '';
  }

  get displayDate(): string {
    const s = this.picture?.capturedTime ?? this.picture?.hygieneDate;
    if (!s) return '';
    if (typeof s === 'string' && s.includes('T')) {
      const datePart = s.split('T')[0];
      if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
      return datePart || s;
    }
    const parts = s.split(' ');
    const ddmmyyyy = parts[0] || '';
    if (/^\d{2}-\d{2}-\d{4}$/.test(ddmmyyyy)) return ddmmyyyy;
    return ddmmyyyy || s;
  }

  /** Location line using roomDisplayName (fallback to roomNo for legacy data) */
  get locationLine(): string {
    const p = this.picture;
    const roomDisplay = p?.roomDisplayName ?? (p as any)?.roomNo;
    if (p?.floorName != null && roomDisplay != null && String(roomDisplay).trim() !== '') {
      return `Floor ${p.floorName} · Room ${roomDisplay}`;
    }
    if (p?.floorName != null) return `Floor ${p.floorName}`;
    return '';
  }

  /** Geolocation: show and open map when latitude/longitude present (full object from card click) */
  get hasGeolocation(): boolean {
    const p = this.picture;
    const lat = p?.latitude;
    const lng = p?.longitude;
    return lat != null && lng != null && String(lat).trim() !== '' && String(lng).trim() !== '';
  }

  get mapUrl(): string {
    const p = this.picture;
    const lat = p?.latitude;
    const lng = p?.longitude;
    if (lat == null || lng == null) return '';
    return `https://www.google.com/maps?q=${encodeURIComponent(String(lat))},${encodeURIComponent(String(lng))}`;
  }

  openMap(): void {
    if (this.mapUrl) window.open(this.mapUrl, '_blank');
  }
}
